<template>
  <v-card
    class="d-flex flex-column secondary--text justify-center"
    min-height="550"
  >
    <div
      class="pa-10 d-flex flex-column align-center"
      style="min-height: 500px"
    >
      <i :class="`icofont-exclamation-circle icofont-6x accent--text`" />

      <div
        class="mb-4 custom-title secondary--text font-weight-medium text-center"
      >
        Upcoming Feature
      </div>
      <div class="text-left">
        We are currently working on a feature that will allow you to proceed
        when defendants requiring service have a different residence. This is
        often the case with co-signers. At this time, you may proceed only if all
        defendants listed in this case reside in the same property.
      </div>
    </div>
    <div>
      <v-btn
        depressed
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent_light"
        @click="close"
      >
        <span
          class=""
          style="font-weight: 600 !important"
        >GO BACK</span>
      </v-btn>
      <v-btn
        depressed
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent"
        @click="close"
      >
        <span
          class=""
          style="font-weight: 600 !important"
        >CANCEL</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "AddTenantDialog",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close:dialog");
    },
  },
};
</script>

<style></style>
